import LauncherPage from "../pages/launcherPage";
import ReservationPage from "../pages/reservationPage";
import PrivacyPolicies from "../pages/privacyPolicies";
import CheckOutPage from "../pages/checkOutPage";
import ConfirmationPageComponent from "../pages/confirmationPage";
import TermsOfServicesPage from "../pages/termsOfServicesPage";
import { Route, Navigate, Routes, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import UTMPersistor from "../Components/UTMPersistor/utmPersistor";
import PaymentPlanPage from "../pages/paymentPlanPage";

const DynamicGoogleTag = () => {
  const location = useLocation();

  return (
    <Helmet>
      {/* Add the async Google tag script */}
      <script
        async
        src="https://www.googletagmanager.com/gtag/js?id=G-RS8S9736X2"
      ></script>
      {/* Add the inline Google tag configuration */}
      <script>
        {`
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', 'G-RS8S9736X2', { 'page_path': '${location.pathname}' });
          `}
      </script>
    </Helmet>
  );
};
const AppRoutes = () => {
  return (
    <>
      <DynamicGoogleTag />
      <UTMPersistor />
      <Routes>
        <Route path="/" element={<LauncherPage />} />
        <Route
          path="/reservation/:email?/:referralCode?"
          element={<ReservationPage />}
        />
        <Route path="/launcher-privacy-policy" element={<PrivacyPolicies />} />
        <Route path="/terms-of-service" element={<TermsOfServicesPage />} />
        <Route path="/payment-plan" element={<PaymentPlanPage />} />

        <Route path="/payment-checkout" element={<CheckOutPage />} />
        <Route path="/confirmation" element={<ConfirmationPageComponent />} />
        <Route path="/*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
};

export default AppRoutes;
